import React from 'react';
import { useAuthStore } from '@/store';
import useTranslation from '@/hooks/useTranslation';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';

// Auth-aware header title for the create-media explore pages (Images / Videos
// / Music). Logged-out visitors see an action-oriented "Create …" label that
// frames these pages as generation entry points; signed-in users keep the
// shorter catalog label.
function MediaRouteHeaderTitle({ loggedInKey, loggedOutKey, fallback }) {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const hasUser = useAuthStore(state => Boolean(state.user?.id));

  const label = hasUser
    ? (t(loggedInKey) || fallback)
    : (t(loggedOutKey) || fallback);

  return (
    <Text
      numberOfLines={1}
      style={{ color: colors.text_color_primary, fontSize: 18, fontWeight: '400' }}
    >
      {label}
    </Text>
  );
}

export default React.memo(MediaRouteHeaderTitle);
